<template>
    <div class="PlayAroundDetails hml_whplt" id="PlayAroundDetails">
        <div class="setailsSwiperBox swiper-container hml_whplt">
            <div class="swiper-wrapper">
                <div class="swiper-slide" style="padding-bottom: .5rem" id="slide">
                    <div class="topBanner swiper-container">
                        <ul class="swiper-wrapper">
                            <li
                            v-for="(item,index) in imgArray"
                            :key="index"
                            class="swiper-slide"
                            >
                                <img :src="item" alt="">
                            </li>
                        </ul>
                        <div class="swiper-pagination"></div>
                    </div>
                    <div class="topTitleBox">
                        <div class="titleBox">
                            <h2>{{ currentData.title }}</h2>
                            <ul class="keywordsList">
                                <!-- <li>{{ item.keywords }}</li> -->
                                <li
                                v-for="(item,index) in currentData.keywords.split('|')"
                                :key="index"
                                >
                                    {{ item }}&nbsp;{{ index == currentData.keywords.split('|').length - 1?'':'|&nbsp;' }} 
                                </li>
                            </ul>
                        </div>
                        <div class="phoneMap" v-if="!specialtyState">
                            <a class="phone" :href="'tel:'+currentData.phone" v-if="currentData.phone">
                                <div class="img" :style="{backgroundImage: 'url('+ ICON +')'}"></div>
                            </a>
                            <div class="map" @click="mapClick">
                                <div class="img" :style="{backgroundImage: 'url('+ ICON +')'}"></div>
                            </div>
                        </div>
                    </div>
                    <div class="addr1" v-if="currentData.addr">
                        <div class="img" :style="{backgroundImage: 'url('+ ICON +')'}"></div>
                        {{ currentData.addr }}
                    </div>
                    <abbreviation v-if="currentData.subSite"></abbreviation>
                    <div class="service" v-if="secondLevelIndex == 0">
                        <h3>便利服务</h3>
                        <ul class="facilitateList">
                            <li v-for="(item,index) in facilitateArr" :key="index" :class="['list' + facilitateList[item - 1].className,'gzw_daj']">
                                <img :src="facilitateList[item - 1].img_url">
                                <span>{{ facilitateList[item - 1].name }}</span>
                            </li>
                        </ul>
                    </div>
                    <textContent></textContent>
                </div>
            </div>
        </div>
        <div class="backBut" @click="backButClick">
            <div class="back">
                <div class="img" :style="{backgroundImage: 'url('+ ICON +')'}"></div>
            </div>
        </div>
        <!-- <backButton :routerName="allData[firstLevelIndex].dataArr[secondLevelIndex].routerName"></backButton> -->
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
import abbreviation from "@/components/abbreviation";
import textContent  from "@/components/textContent";
import Swiper from "swiper";
import 'swiper/css/swiper.css';
export default {
    data() {
        return {
            wxshareData: {
                title: "慢游京山",
                desc: "慢游京山",
                link: "http://www.hmltec.com/720/jingshan/index.html",
                imgUrl: "http://www.hmltec.com/720/jingshan/logo.png"
            },
            currentData: {},
            facilitateList: [
				{
					className: 1,
					img_url: require("@/assets/svg/details/wifi.svg"),
					name: "WIFI"
				},
				{
					className: 2,
					img_url: require("@/assets/svg/details/alarmClock.svg"),
					name: "叫醒"
				},
				{
					className: 3,
					img_url: require("@/assets/svg/details/Washing.svg"),
					name: "洗衣机"
				},
				{
					className: 4,
					img_url: require("@/assets/svg/details/breakfast.svg"),
					name: "早餐"
				},
				{
					className: 5,
					img_url: require("@/assets/svg/details/Parking.svg"),
					name: "停车场"
				},
				{
					className: 6,
					img_url: require("@/assets/svg/details/airConditioner.svg"),
					name: "空调"
				},
				{
					className: 7,
					img_url: require("@/assets/svg/details/television.svg"),
					name: "电视"
				},
				{
					className: 8,
					img_url: require("@/assets/svg/details/luggage.svg"),
					name: "行李寄存"
				},
				{
					className: 9,
					img_url: require("@/assets/svg/details/fastWIFI.svg"),
					name: "高速上网"
				},
				{
					className: 10,
					img_url: require("@/assets/svg/details/h24.svg"),
					name: "24h前台"
				},
				{
					className: 11,
					img_url: require("@/assets/svg/details/conference.svg"),
					name: "会议室"
				},
				{
					className: 12,
					img_url: require("@/assets/svg/details/entertainment.svg"),
					name: "棋牌室"
				}
            ],
            facilitateArr: [1,3,5,6,7,8],
            swiper: null,
            imgArray: [],
        }
    },
    mounted(){
        this.swiper = new Swiper('.setailsSwiperBox',{
            direction: 'vertical',
            slidesPerView: 'auto',
            freeMode: true,
        });
        var mySwiper = new Swiper('.topBanner',{
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
        })
    },
    created(){
        let index1 = this.specialtyState? 5 : this.firstLevelIndex;
        let index2 = this.specialtyState? 0 : this.secondLevelIndex;
        this.currentData = this.allData[index1].dataArr[index2].list[this.levelThreeIndex];
        let imgArray = this.currentData.images.replace(/\n/g,"").split("<br />");
        imgArray.forEach((item,index) => {
            if(item.length > 10 && item.indexOf("gps") == -1){
                if(item.split("|")[2]){
                    this.getImgSrc(item.split("|")[2],1).forEach((value,ind) => {
                        this.imgArray.push(value);
                    });
                }
                
            }
        });
        this.wxshareData.title = this.currentData.title;
        console.log(window.location.href.split("?")[0]);
        this.wxshareData.link = window.location.href.split("?")[0] + "?firstLevelIndex="+ this.firstLevelIndex +"&secondLevelIndex=" + this.secondLevelIndex + "&levelThreeIndex=" + this.levelThreeIndex + "&url=" + (this.secondLevelIndex==0?'/hotel':'/restaurant');
        let wxshareData = this.wxshareData;
        console.log(wxshareData);
        wx.onMenuShareAppMessage({
                title: wxshareData.title, // 分享标题
                link: wxshareData.link, // 分享链接
                imgUrl: wxshareData.imgUrl, // 分享图标
                desc: wxshareData.desc, // 分享描述
                success () {
                    console.log("成功");
                },
                cancel () {
                    console.log("失败");
                }
            });
            wx.onMenuShareTimeline({
                title: wxshareData.title, // 分享标题
                link: wxshareData.link, // 分享链接
                imgUrl: wxshareData.imgUrl, // 分享图标
                desc: wxshareData.desc, // 分享描述
                success () {
                    console.log("成功");
                },
                cancel () {
                    console.log("失败");
                }
            })
    },
    methods: {
        mapClick(){
            this.setGetIntoTheState(2);
            this.$router.push("/map");
        },
        backButClick(){
            this.setPlayAroundDetailsFlag(false);
        },
        ...publicData.mapMutations(["setPlayAroundDetailsFlag","setGetIntoTheState","setMapJumpListFlag"])
    },
    beforeDestroy(){
        // this.scroll.disable();
        // this.scroll.destroy();
        // this.scroll = null;
    },
    computed: {
        ...publicData.mapState(["allData","firstLevelIndex","secondLevelIndex","levelThreeIndex","specialtyState"])
    },
    components: {
        abbreviation,
        textContent
    }
}
</script>

<style lang="scss" scoped>
.PlayAroundDetails{
    background: #fff;
    z-index: 100;
    .backBut{
        width: 1rem;
        height: 1rem;
        position: absolute;
        left: 0;
        top: 0;
        padding-top: .16rem;
        padding-left: .4rem;
        z-index: 10;
        .back{
            width: .5rem;
            height: .5rem;
            // background: rgba(0,0,0,.4);
            border-radius: 50%;
            .img{
                width: 100%;
                height: 100%;
                background-repeat: no-repeat;
                background-position: -1rem 0rem;
                background-size: 2rem 1.1rem;
            }
        }
    }
    .setailsSwiperBox {
        position: absolute;
        >.swiper-wrapper{
            >.swiper-slide{
                height: auto;
                
            }
        }
    }
    .topBanner{
        width: 100%;
        height: 4.22rem;
        img{
            height: 100%;
        }
        .swiper-pagination{
            width: 1rem;
            height: .5rem;
            border-radius: .25rem;
            background: rgba(0,0,0,.5);
            font-size: .22rem;
            color: rgba(255,255,255,.7);
            display: flex;
            align-items: center;
            justify-content:center;
            &.swiper-pagination-fraction{
                left: auto;
                right: .48rem!important;
                bottom: .2rem;
            }
        }
        ul{
            li{

            }
        }
    }
    .addr1{
        font-size: .24rem;
        color: #666;
        padding-left: .4rem;
        margin-bottom: .3rem;
        display: flex;
        align-items: center;
        .img{
            width: .28rem;
            height: .32rem;
            background-repeat: no-repeat;
            background-position: -1rem -.6rem;
            background-size: 2rem 1.1rem;
            // margin-right: .06rem;
            transform: scale(0.8);
        }
    }
    .topTitleBox{
        padding: 0 .4rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: .5rem;
        margin-bottom: .2rem;
        .titleBox{
            h2{
                font-size: .46rem;
                color: #333;
                font-weight: bold;
            }
            .keywordsList{
                display: flex;
                align-items: center;
                margin-top: .2rem;
                li{
                    font-size: .24rem;
                    color: #999;
                }
            }
        }
        .phoneMap{
            display: flex;
            >div,a{
                width: .66rem;
                height: .66rem;
                border: .02rem solid #5BC2AB;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                &.phone{
                    margin-right: .35rem;
                    .img{
                        width: .34rem;
                        height: .34rem;
                        background-repeat: no-repeat;
                        background-position: -.5rem -.6rem;
                        background-size: 2rem 1.1rem;
                    }
                }
                &.map{
                    .img{
                        width: .28rem;
                        height: .32rem;
                        background-repeat: no-repeat;
                        background-position: -1rem -.6rem;
                        background-size: 2rem 1.1rem;
                    }
                }
            }
        }
    }
    .service{
        padding: 0 .4rem;
        margin-top: .94rem;
        margin-bottom: .98rem;
        h3{
            font-size: .36rem;
            color: #333;
        }
        .facilitateList{
            margin-top: .12rem;
            display: flex;
            flex-wrap: wrap;
            li{
                width: (100%)/6;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                margin-top: .2rem;
                &:first-of-type{
                    margin-left: 0;
                }
                span{
                    white-space:nowrap;
                    font-size: .20rem;
                    color: #333;
                    margin-top: .10rem;
                    padding: 0 .10rem;
                    transform: scale(0.95);
                }
                &.list1{
                    img{
                        width: .56rem;
                        height: .40rem;
                    }
                }
                &.list2{
                    img{
                        width: .40rem;
                        height: .40rem;
                    }
                }
                &.list3{
                    img{
                        width: .32rem;
                        height: .40rem;
                    }
                }
                &.list4{
                    img{
                        width: .42rem;
                        height: .40rem;
                    }
                }
                &.list5{
                    img{
                        width: .40rem;
                        height: .40rem;
                    }
                }
                &.list6{
                    img{
                        width: .37rem;
                        height: .40rem;
                    }
                }
                &.list7,&.list11{
                    img{
                        width: .44rem;
                        height: .40rem;
                    }
                }
                &.list8{
                    img{
                        width: .32rem;
                        height: .40rem;
                    }
                }
                &.list9,&.list10{
                    img{
                        width: .45rem;
                        height: .40rem;
                    }
                }
                &.list12{
                    img{
                        width: .46rem;
                        height: .40rem;
                    }
                }
            }
        }
    }
    /deep/.textContent{
        margin-top: .8rem;
    }
}
</style>